import styled from 'styled-components';

import { colorWhite, mediaQueryMobileMin } from 'styles';

export const FiltersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ButtonGroupWrapper = styled.div`
  display: inline-flex;
  margin-top: 16px;
  width: 100%;

  button[data-checked='true'] {
    color: ${colorWhite};
  }

  @media all and ${mediaQueryMobileMin} {
    width: auto;
  }
`;
